<div class='text-left primary-controls'>
    <button class="btn btn-primary submit-button submit-button-sm"
            (click)="importLocations()">{{LOCALIZATION.import}}</button>
    <button class="btn btn-primary submit-button submit-button-sm"
            (click)="loadSavedLocations(1)">{{LOCALIZATION.refresh}}</button>
</div>
<br>
<div *ngIf="mylocations && mylocations.length > 0">
    <div class="saved-locations-pagination-container">
		<div class="text-center" *ngIf="pagination.totalElements > pagination.elementsPerPage">
			  <ngb-pagination class="pagination custom-page pagination-sm"
			    [(page)]="pagination.page" 
			    [pageSize]="pagination.elementsPerPage"
			    [collectionSize]="pagination.totalElements" 
			    (pageChange)="pagination.pageChanged($event)"
			    [maxSize]="3"
			    [boundaryLinks]="true"
			    previousText="&#xf053;"
			    nextText="&#xf054;"
			    firstText="&#xf053;&#xf053;"
			    lastText="&#xf054;&#xf054;">
			  </ngb-pagination>					
		</div>
    </div>     
</div>
<div *ngFor='let location of mylocations'>
    <div class="row" style="margin:0px">
        <div class="col-sm-6 truncate text-left">
            <p style="font-size:14px;font-weight:400;margin-left:5px" class="truncate" title="{{location.name}}">{{location.name}}</p>
        </div>
        <div class="col-sm-6 text-right" style="padding:0px">
            <button class="btn btn-sm text-grey background-white" title="Search on Location"
                    (click)="searchLocation(location, $event);"><i
                    class="fa fa-search fa-1x" aria-hidden="true"></i></button>
            <button class="btn btn-sm text-grey background-white" title="{{LOCALIZATION.zoomToLocation}}"
                    (click)="zoomToLocation(location, $event);"><i
                    class="fa fa-globe-americas fa-1x" aria-hidden="true"></i></button>
            <button class="btn btn-sm text-grey background-white" title="Rename Location"
                    (click)="editLocation(location, $event);"><i
                    class="fa fa-pencil-alt fa-1x" aria-hidden="true"></i></button>
            <button class="btn btn-sm text-red background-white" title="Delete Location"
                    (click)="deleteLocation(location, $event);"><i
                    class="fa fa-times fa-1x" aria-hidden="true"></i></button>
        </div>
    </div>
</div>
<div *ngIf="mylocations && mylocations.length == 0"> <i>{{LOCALIZATION.savedLocationsEmpty}}</i></div>
